import React from 'react';
import Field from '../../shared/ui/Field';
import DropdownSelectControl from '../../shared/ui/DropdownSelectControl';
import { useFieldController } from '../../../../helpers/formManager';
import {
  defaultIntervalAvailability,
  intervalAvailabilities,
} from '../../shared/configs/selectionData/intervalAvailabilities';
import styles from './index.module.scss';

const options = [...intervalAvailabilities.entries()].map(([key, content]) => ({
  key,
  value: key,
  content,
}));

const SelectIntervalAvailability = ({ name, className }) => {
  const {
    field: { value, onChange },
  } = useFieldController({
    name,
    defaultValue: defaultIntervalAvailability,
    rules: { required: 'Выберите доступность интервала' },
  });

  return (
    <Field.Memoized
      type={Field.types.dropdownSelect}
      value={value}
      onChange={onChange}
      options={options}
      renderControl={getRenderControl(value)}
      rootCN={className}
    />
  );
};

export default SelectIntervalAvailability;

function getRenderControl(value) {
  return (props) => {
    const { visible, loading, disabled, className, ...rest } = props;

    return (
      <DropdownSelectControl
        {...rest}
        visible={visible}
        loading={loading}
        disabled={disabled}
        className={styles.btn}
      >
        {intervalAvailabilities.get(value) ?? 'Выбрать из списка'}
      </DropdownSelectControl>
    );
  };
}
